/**
 * Escapes HTML special characters to prevent XSS attacks
 * @param {string} str - The string to escape
 * @returns {string} The escaped string
 */
function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Shared tooltip formatter for axis-triggered charts (bar, line, stacked, etc.)
 * Filters out empty values and truncates long series names
 * @param {Array} params - ECharts tooltip params array
 * @returns {string} HTML string for tooltip content
 */
export function axisTooltipFormatter(params) {
  if (!params || params.length === 0) return '';

  const filtered = params.filter(
    (p) => p.value !== null && p.value !== undefined && p.value !== '',
  );

  if (filtered.length === 0) return '';

  const axisValue = escapeHtml(params[0].axisValue);
  const title = `<div style="margin-bottom: 8px; font-weight: bold;">${axisValue}</div>`;

  const items = filtered
    .map((p) => {
      const seriesName = escapeHtml(p.seriesName);
      return `<div style="margin: 4px 0; display: flex; align-items: center;">
        <span style="display: inline-block; width: 10px; height: 10px; background: ${p.color}; border-radius: 50%; margin-right: 8px; flex-shrink: 0;"></span>
        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;" title="${seriesName}">${seriesName}</span>
        <span style="margin-left: 8px; font-weight: bold; flex-shrink: 0;">${p.value}</span>
      </div>`;
    })
    .join('');

  return `${title}${items}`;
}
